module.exports = __webpack_public_path__ + "static/test-9049c2078fb9cc522bd365558701478e.png";